module.exports = "pegasus/assets/graycircle-google.png";